<script setup lang="ts">import { createPropsRestProxy } from '/vue-macros/reactivity-transform/helper';
const content = createPropsRestProxy(__props, ["item","root"]);

import Tooltip from "@/components/Tooltip/Tooltip.vue";

import type EvidenceCount from "@/models/RecordEvidenceCount";
import type { TooltipRootProps, TooltipContentProps } from "reka-ui";

withDefaults(defineProps<
  { item: EvidenceCount; root?: TooltipRootProps } & TooltipContentProps
>(), {  })
</script>
<template>
  <Tooltip :content-props="content" :root-props="root">
    <template #trigger>
      <slot :disabled="root?.disabled" />
    </template>
    <template #content>
      <template v-if="item && item.name">
        <ul>
          <li>{{ item.name }}: {{ item.value }}</li>
        </ul>
      </template>
      <h2 v-else>Instance has no counts</h2>
    </template>
  </Tooltip>
</template>
